import { PreSalesQuestion } from '../dto/model';

// LEAD-409: temporary exclusion of PV from the unified flow. See docs/unified-flow-pv.md.
export const TEMPORARILY_ENABLE_UNIFIED_PRE_SALES_PV = false;

export const isUnifiedPreSalesProductEnabled = (product: string): boolean =>
  TEMPORARILY_ENABLE_UNIFIED_PRE_SALES_PV || product.toUpperCase() !== 'PV';

export const isUnifiedPreSalesQuestionEnabled = (question: PreSalesQuestion): boolean => {
  if (TEMPORARILY_ENABLE_UNIFIED_PRE_SALES_PV) return true;
  const products = question.products ?? (question.product ? [question.product] : []);
  return products.length === 0 || products.some(isUnifiedPreSalesProductEnabled);
};
